"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MongoLogChannel = exports.ElasticLogChannel = exports.ConsoleLogChannel = exports.LogLevels = exports.logManager = void 0;
const events_1 = require("events");
const Logger_1 = require("./Logger");
const LogTypes_1 = require("./LogTypes");
Object.defineProperty(exports, "LogLevels", { enumerable: true, get: function () { return LogTypes_1.LogLevels; } });
class LogManager extends events_1.EventEmitter {
    constructor() {
        super(...arguments);
        this.options = {
            level: LogTypes_1.LogLevels.WARN,
            agreement_number: "",
            release: "Not set",
        };
    }
    onLogEntry(listener) {
        this.on("log", listener);
    }
    /**
     * @returns pre-configured logger object with logging functions.
     */
    getLogger() {
        return new Logger_1.Logger(this, this.options);
    }
    /**
     * Sets the configuration for the log manager.
     * @param options The configuration that should be used by the logger
     * @returns `this` for chaining purpose.
     */
    configure(options) {
        if (options.level)
            this.options.level = options.level;
        if (options.agreement_number)
            this.options.agreement_number = options.agreement_number;
        if (options.release)
            this.options.release = options.release;
        return this;
    }
    /**
     * @returns the current log level of the log manager.
     */
    getLevel() {
        return this.options.level;
    }
    /**
     * Removes all registered log channels from the log manager.
     * @returns `this` for chaining purpose.
     */
    unregisterAllHandlers() {
        this.removeAllListeners("log");
        return this;
    }
    /**
     * Registers a new log channel to use when logging.
     * @param logChannel
     * @returns `this` for chaining purpose.
     */
    registerLogChannel(logChannel) {
        this.onLogEntry(logChannel.log);
        return this;
    }
}
exports.logManager = new LogManager();
var ConsoleLogChannel_1 = require("./ConsoleLogChannel");
Object.defineProperty(exports, "ConsoleLogChannel", { enumerable: true, get: function () { return ConsoleLogChannel_1.ConsoleLogChannel; } });
var ElasticLogChannel_1 = require("./ElasticLogChannel");
Object.defineProperty(exports, "ElasticLogChannel", { enumerable: true, get: function () { return ElasticLogChannel_1.ElasticLogChannel; } });
var MongoLogChannel_1 = require("./MongoLogChannel");
Object.defineProperty(exports, "MongoLogChannel", { enumerable: true, get: function () { return MongoLogChannel_1.MongoLogChannel; } });
